export default "__VITE_ASSET__CgZj0JB0__"